/** Version affichée dans le shell (header/footer). */
export const APP_VERSION = "1.7.0";
